import {
  CreateResolutionConfiguration,
  CreateResolutionSetup
} from '@bo-components/resolutions/resolutionDetails';
import {
  ResolutionDetailsStepperContext,
  useCreateResolution
} from '@bo-hooks/resolutions/resolutionDetails';
import { useContext } from 'react';

export const CreateResolution = () => {
  const { onChangeResolutionSetup, resolutionSetup } = useCreateResolution();
  const { currentResolutionStep, onClickNextNewResolutionStep } = useContext(
    ResolutionDetailsStepperContext
  );

  if (currentResolutionStep === 1) {
    return (
      <CreateResolutionSetup
        onChangeResolutionSetup={onChangeResolutionSetup}
        onClickContinue={onClickNextNewResolutionStep}
        resolutionSetup={resolutionSetup}
      />
    );
  }

  return <CreateResolutionConfiguration resolutionSetup={resolutionSetup} />;
};
